import { render, staticRenderFns } from "./Jury.vue?vue&type=template&id=58aff736&scoped=true&"
import script from "./Jury.vue?vue&type=script&lang=js&"
export * from "./Jury.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aff736",
  null
  
)

export default component.exports